<template>
  <!--div class="container"-->
    <form accept-charset="UTF-8" role="form" @submit.stop.prevent="handleSubmit">
      <h2>Login</h2>
      <p class="text-muted">Sign In to your account</p>
      <div class="alert alert-success" v-show="successMessage">
        {{ successMessage }}
      </div>
      <div class="alert alert-danger" v-show="errorMessage">
        {{ errorMessage }}
      </div>
      <fieldset>
        <div class="input-group mb-3">
          <span class="input-group-addon"><i class="icon-user"></i></span>
          <input class="form-control" placeholder="Customer ID" name="username" type="text" v-model="username"
                 required min="1" pattern="[0-9]+" :disabled="disableAllInputs"
                 oninvalid="setCustomValidity('Numeric Customer ID required (not your name or email). Spaces and non-numeric characters are not allowed')"
                 oninput="setCustomValidity('')">
        </div>
        <div class="input-group mb-4">
          <span class="input-group-addon"><i class="icon-lock"></i></span>
          <input class="form-control" placeholder="Password" name="password" type="password" v-model="password"
                 required min="8" pattern="[\S]+" :disabled="disableAllInputs">
        </div>
        <div class="row">
          <div class="col-sm-6 col text-sm-left text-center">
            <input class="btn btn-primary px-4" type="submit" value="Login"
                   :disabled="protectedUI || !formIsValid || disableAllInputs">
          </div>
          <div class="col-sm-6 col text-sm-left text-center">
            <router-link :to="{ name: 'ForgotPassword' }" class="btn btn-link px-0">Forgot Password</router-link>
          </div>
        </div>
      </fieldset>
    </form>
  <!--/div-->
</template>

<script>
  import { BACKEND_SERVICE } from '../../http-common-service'

  export default {
    name: 'Login',
    data: () => ({
      errorMessage: null,
      successMessage: null,
      disableAllInputs: false,
      protectedUI: false,
      username: '',
      password: '',
      tenant: '',
      submitTimes: 0
    }),
    methods: {
      handleSubmit () {
        if (this.submitTimes > 2) {
          this.errorMessage = 'Error submitting.  Please reload and try again later.'
          return false
        }

        this.submitTimes++
        // Remove alert boxes
        this.successMessage = null
        this.errorMessage = null

        this.protectedUI = true
        this.$raven.setUserContext({
          username: this.username
        })

        this.$store.dispatch('authenticateUser', {
          username: this.username,
          password: this.password
        }).then((result) => {
          if (result.userConfirmationNecessary) {
            this.$router.push({ name: 'PasswordChallenge', params: { forwarded: true } })
          } else {
            this.disableAllInputs = true
            this.password = ''
            this.errorMessage = null
            this.successMessage = 'Successfully signed in'
            this.$router.push({ path: '/' })
          }
        }).catch((err) => {
          if (err.message.indexOf('User account has expired') >= 0) {
            this.unexpireUser()
          } else {
            console.log(err)
            this.$raven.captureException(err)
            this.errorMessage = err.message
            this.protectedUI = false
          }
        })
      },
      assignUser (user) {
        if (user === '' || user === undefined) {
          return false
        }
        this.username = user
        return true
      },
      assignPassword (password) {
        if (password === '' || password === undefined) {
          return false
        }
        this.password = password
        return true
      },
      unexpireUser () {
        BACKEND_SERVICE({
          method: 'put',
          url: 'scms/v1/tenants/' + this.tenant + '/users/' + this.username + '/refreshExpiration',
          responseType: 'arraybuffer'
        })
          .then(response => this.handleSubmit())
          .catch(err => {
            this.errorMessage = err.message
            this.protectedUI = false
            console.log(err)
            this.$raven.captureException(err)
          })
      },
      updateTenant () {
        this.tenant = this.$store.state.tenant
      }
    },
    created () {
      if (this.$store.getters.cognitoAuthenticated) {
        this.$router.push({path: '/'})
      }
      this.updateTenant()
    },
    computed: {
      formIsValid () {
        return /[\S]+/.test(this.username)
      }
    },
    mounted: function () {
      // if query param 'u' provided, automatically add that to username
      // and submit form
      let username = this.$route.query.u
      let password = this.$route.query.p
      if (this.assignUser(username) && this.assignPassword(password)) {
        this.$router.replace({ name: 'Login' })
        this.handleSubmit()
      }
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/auth/Login.vue?95551b2c